import { useState, useEffect } from 'react';
import { adminLogin } from '../api/userApi';


interface UseAdminLoginResult {  
  loading: boolean;
  error: string | null;
  adminLogin: (email: string, password: string) => Promise<{success: boolean}>;
}

export function useAdminLogin(): UseAdminLoginResult {
  
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const login = async (email: string, password: string): Promise<{success: boolean}> => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminLogin(email, password);
      console.log(res);
      if (res.data.error) {       
        setError(res.data.error);
        return { success: false };
      } else {
        sessionStorage.setItem('adminToken', String(res.data.token));
        sessionStorage.setItem('csiEmail', email);        
        return { success: true };
      }
    } catch (e: any) {
      setError('Failed to login: ' + (e?.message || e));
      return { success: false };
    } finally {
      setLoading(false);
    }  
  };

  return { adminLogin: login, loading: loading, error: error }
}
